import { isHK } from '@didi/webx-js'
import { HKDomainConvert } from '../../js/hk_url'

const API_HOST = process.env.npm_config_mock ? '' : process.env.API_NORMAL

export const GlobalConfig = {
  OIDPath: HKDomainConvert(
    'https://common.diditaxi.com.cn/webapp/platform/oauth2/openid',
    isHK
  ),
  /* cspell: disable-next-line */
  LocationToCityIdAPI: HKDomainConvert(
    '//common.diditaxi.com.cn/webcore/geo/reversegeotop',
    isHK
  ),
  LoginConfig: {
    loginType: 'trinity',
    productType: 'didi',
    useOauthCode: true,
    offline: process.env.PASSPORT_ENV === 'offline',
  },
  Pay: {
    mini_url: {
      xwebapp: '/pay/pages/index',
      qingju: '/subpackages/paymentProcess/common_pay/common_pay',
      shunfengche: '/pages/subPacks/pay/index',
      marking: '/pages/paymentPage/index',
    },
    appid: {
      esapp: 'wxe9875a55496b6b34',
    },
  },
  Urls: {
    rules: {
      'zh-CN': HKDomainConvert('https://s.didi.cn/ryloXb', isHK),
      'en-US': HKDomainConvert('https://v.didi.cn/p/7KMM7M', isHK),
      'zh-HK': HKDomainConvert('https://v.didi.cn/xAbj9p7', isHK),
    },
  },
  APIs: {
    // 首页
    homepage: `${API_HOST}/goods/homepage`, // 首页聚合
    goodsList: `${API_HOST}/goods/lists`, // 商品列表
    goodsMore: `${API_HOST}/goods/more`, // 商品列表 - 翻页
    userInfo: `${API_HOST}/user/info`, // 用户信息
    orderList: `${API_HOST}/order/lists`, // 订单列表
    shareConfig: `${API_HOST}/goods/share`,
    goodsDetailNormal: `${API_HOST}/goods/info`,
    goodsProcessInfo: `${API_HOST}/activity/getDoingGoodsInfo`, // 进行中页面接口（商品信息、订单号、团信息等）
    groupRolling: `${API_HOST}/activity/groupRolling`,
    serverTimeSyncSpike: `${API_HOST}/sys/dateline`,
    getRecommendList: `${API_HOST}/goods/recommend`,
    createOrderNormal: `${API_HOST}/order/create`,
    createOrderGroup: `${API_HOST}/order/createGroup`,
    getPayInfo: `${API_HOST}/order/getPayParam`, // 虽然是普通服务器的接口，但是目前只有秒杀用
    getOrderInfo: `${API_HOST}/order/info`,
    bogoBind: `${API_HOST}/shareCoupon/bind`, // 买一赠一领取
    updateOrder: `${API_HOST}/order/update`, // 更新订单
    createOrderProxy: `${API_HOST}/order/createOut`, // 待购买
    getApollo: `${API_HOST}/goods/homepage/conf`, // apollo 配置， 后期废弃
    getXenvConf: `${API_HOST}/goods/xenv/conf`, // apollo xenv 配置
    orderClose: `${API_HOST}/order/close`, // 取消订单
    getOrderPayInfo: `${API_HOST}/get/payInfo`, // 获取用户支付三元组
    getPayStatus:
      'https://pay.udache.com/gulfstream/pay/v1/didipay/getPayStatus',
    updateIndexRecommend: `${API_HOST}/goods/highlyRecommend`,
  },
}
